import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import AxiosService from "../../services/AxiosHelper";

const baseURL = process.env.REACT_APP_BASEURL;

export const getInvitations = createAsyncThunk(
  "invitation/getInvitations",
  async (filters, { rejectWithValue }) => {
    try {
      const { status = 'all', search = '', page = 1, limit = 10, businessId = '' } = filters;
      let queryUrl = baseURL + `/v1/invitations?page=${page}&limit=${limit}&status=${status}&search=${search}&businessId=${businessId}`;
      
      const response = await AxiosService.AxiostRequest({
        url: queryUrl,
        method: "get",
      });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fetch invitations");
    }
  }
);

export const sendInvitation = createAsyncThunk(
  "invitation/sendInvitation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosService.AxiostRequest({
        url: baseURL + `/v1/invitations/send`,
        method: "post",
        data
      });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to send invitation");
    }
  }
);

export const resendInvitation = createAsyncThunk(
  "invitation/resendInvitation",
  async (customerId, { rejectWithValue }) => {
    try {
      const response = await AxiosService.AxiostRequest({
        url: baseURL + `/v1/invitations/resend/${customerId}`,
        method: "post",
      });
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to resend invitation");
    }
  }
);

const invitationSlice = createSlice({
  name: "invitation",
  initialState: {
    invitations: [],
    loading: false,
    sending: false,
    stats: { total: 0, activated: 0, pending: 0, expired: 0 },
    pagination: { page: 1, pages: 1, total: 0 },
    filters: { status: 'all', search: '' },
    error: null
  },
  reducers: {
    setFilter: (state, action) => {
      const { key, value } = action.payload;
      state.filters[key] = value;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getInvitations.fulfilled, (state, action) => {
      state.invitations = action.payload.invitations;
      state.pagination = action.payload.pagination;
    });
    builder.addCase(sendInvitation.fulfilled, (state, action) => {
      state.invitations.unshift(action.payload.customer);
      toast.success("Invitation sent successfully");
    });
    builder.addCase(resendInvitation.fulfilled, (state) => {
      toast.success("Invitation resent successfully");
    });

    builder.addMatcher(
      (action) => action.type.startsWith("invitation/") && action.type.endsWith("/pending"),
      (state, action) => {
        if (action.type.includes("sendInvitation") || action.type.includes("resendInvitation")) {
          state.sending = true;
        } else {
          state.loading = true;
        }
      }
    );
    builder.addMatcher(
      (action) => action.type.startsWith("invitation/") && (action.type.endsWith("/fulfilled") || action.type.endsWith("/rejected")),
      (state, action) => {
        state.loading = false;
        state.sending = false;
        if (action.type.endsWith("/rejected")) {
          state.error = action.payload;
          toast.error(action.payload?.message || "Operation failed");
        }
      }
    );
  },
});

export const { setFilter } = invitationSlice.actions;
export default invitationSlice.reducer;
